import React from "react";
import Navbar from "../navbar/Navbar";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import imagecanada from "../../assets/canada.png";
import imageuk from "../../assets/united-kingdom.png";
import imagefrance from "../../assets/france.png";
import imageAus from "../../assets/australia.png";
import imageItaly from "../../assets/italy.png";
import imagenz from "../../assets/nz.png";
import imageSpain from "../../assets/spain.png";
import imagegermany from "../../assets/germany.png";
import imagechina from "../../assets/china.png";
import imageOne from "../../assets/banner-1.jpg";
import imageusa from "../../assets/united-states.png";
import imageTwo from "../../assets/banner-2.jpg";
import imageThree from "../../assets/banner-3.jpg";
import imageCost from "../../assets/Cost-Effective-01.jpg";
import imageProcesser from "../../assets/Faster_Processing.jpg";
import imageInterview from "../../assets/DirectInterviews_one.png";
import imageVisa from "../../assets/VisaAssistance-01.jpg";

import Footer from "../Footer/footer";

const Home = () => {
  return (
    <div>
      <div className="banner-section">
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={imageOne} className="d-block w-100" alt="..."/>
          <div className="carousel-caption d-none d-md-block">
            <h5 className="display-4">Make your overseas dreams            </h5>
            <p>come true!</p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={imageTwo} className="d-block w-100" alt="..."/>
          <div className="carousel-caption d-none d-md-block">
            <h5 className="display-4">Make your overseas dreams            </h5>
            <p>come true!</p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={imageThree} className="d-block w-100" alt="..."/>
          <div className="carousel-caption d-none d-md-block">
            <h5 className="display-4">Make your overseas dreams            </h5>
            <p>come true!</p>
          </div>
        </div>
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  </div>
      <div className="osc-section pt-5 pb-5">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h2 className="display-5">
                    {" "}
                    Our successful <span className="text-c-2">700 Clients</span>...
                    <br />
                    Flyurdream here to help grow faster
                  </h2>
                </div>
                <p className="text-center">
                  Flyurdream is an International Student
                  Recruitment Organization that assists students in pursuing
                  overseas education in universities in UK, USA, Australia, New
                  Zealand, Canada, Switzerland, etc. Flyurdream is a
                  solution-oriented company, which specializes in tailoring
                  career pathways to suit individual profiles within the
                  constraints that may prevail in each case. The constraints may
                  be educational, financial or personal.
                </p>
              </div>
            </div>
            <div className="row" >
              <div className="col-md-12">
                <ul className="osc-section-list">
                  <li>
                    <div className="shadow-sm p-4 mb-4  text-center" href="student">
                    <a className="icon-home" href="/student">
                      <i className="ri-user-2-fill"></i>
                      </a>
                      <h2 className="display-6">Students</h2>
                      {/* <p>
                        Dreaming of studying abroad? At FlyUrDream, we make your
                        international education journey{" "}
                      </p> */}
                      <a href="/student">
                        <i className="ri-arrow-right-double-line"></i>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="shadow-sm p-4 mb-4  text-center" href="/recruitment-partner">
                    <a className="icon-home" href="/recruitment-partner">
                      <i className="ri-shake-hands-fill"></i>
                      </a>
                      <h2 className="display-6">Recruitment Partners</h2>
                      {/* <p>
                        Dreaming of studying abroad? At FlyUrDream, we make your
                        international education journey{" "}
                      </p> */}
                      <a href="/recruitment-partner">
                        <i className="ri-arrow-right-double-line"></i>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="shadow-sm p-4 mb-4  text-center" href="/institutions-page">
                    <a className="icon-home" href="/institutions-page">
                      <i className="ri-bank-fill"></i>
                      </a>
                      <h2 className="display-6">Institutions</h2>
                      {/* <p>
                        Dreaming of studying abroad? At FlyUrDream, we make your
                        international education journey{" "}
                      </p> */}
                      <a href="/institutions-page">
                        <i className="ri-arrow-right-double-line"></i>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="shadow-sm p-4 mb-4  text-center">
                    <a className="icon-home" href="/franchise-page">
                      <i className="ri-briefcase-4-fill"></i>
                      </a>
                      <h2 className="display-6">Franchise</h2>
                      {/* <p>
                        Dreaming of studying abroad? At FlyUrDream, we make your
                        international education journey{" "}
                      </p> */}
                      <a href="/franchise-page">
                        <i className="ri-arrow-right-double-line"></i>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bct-section pt-5">
        <div className="container-fluid">
          <div className="container">
            <div className="section-title">
              <h6>Countries We Offer </h6>
              <h2 className="display-5"> Best Countries to Travel</h2>
            </div>
            <div className="row">
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="Education"
                  role="tabpanel"
                  aria-labelledby="Education-tab"
                >
                  <div>
                  <ul className="country-list">
                      <li>
                        <a>
                          <img src={imageusa} alt="" /> United
                          States
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagecanada} alt="" /> canada
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imageuk} alt="" /> United
                          Kingdom
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagefrance} alt="" /> France
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagegermany} alt="" /> Germany
                        </a>
                      </li>
                      {/* <li>
                        <a href="javascript:void(0)">
                          <img src={imagechina} alt="" /> China
                        </a>
                      </li> */}
                      <li>
                        <a>
                          <img src={imageAus} alt="" />{" "}
                          Australia
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagenz} alt="" /> New Zealand
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imageItaly} alt="" /> Italy
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imageSpain} alt="" /> Spain
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="Travel"
                  role="tabpanel"
                  aria-labelledby="Travel-tab"
                >
                  <div>
                    <ul className="country-list">
                      <li>
                      <a >
                          <img src="images/united-states.png" alt="" /> United
                          States
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/canada.png" alt="" /> canada
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/united-kingdom.png" alt="" /> United
                          Kingdom
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/france.png" alt="" /> France
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/germany.png" alt="" /> Germany
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/china.png" alt="" /> China
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/united-states.png" alt="" />{" "}
                          Australia
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/canada.png" alt="" /> New Zealand
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/united-kingdom.png" alt="" /> Italy
                        </a>
                      </li>
                      <li>
                      <a >
                          <img src="images/france.png" alt="" /> Spain
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cr-section mt-5">
        <div className="container-fluid">
          <div className="container">
            <div className="section-title">
              <h6>Client Reviews</h6>
              <h2 className="display-5"> What our customers are saying</h2>
            </div>
            <div className="row">
              <div className="col-md-12 mb-4 ">
                <div
                  id="carouselExampleControls"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="row">
                    <div className="col-md-6 col-sm-6 col-6">
                      <button
                        className="carousel-control-prev border-1 shadow-sm "
                        type="button"
                        data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev"
                      >
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                    </div>
                    <div className="col-md-6 col-sm-6 col-6">
                      <button
                        className="carousel-control-next border-1 shadow-sm "
                        type="button"
                        data-bs-target="#carouselExampleControls"
                        data-bs-slide="next"
                      >
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>

                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="row ">
                        <div className="col-md-6 ">
                          <div className="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div className="text-end pt-2">Deepak Arora</div>
                        </div>

                        <div className="col-md-6">
                          <div className="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div className="text-end pt-2">Hari Kiran</div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="row ">
                        <div className="col-md-6 ">
                          <div className="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div className="text-end pt-2">Deepak Arora</div>
                        </div>

                        <div className="col-md-6">
                          <div className="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div className="text-end pt-2">Hari Kiran</div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="row ">
                        <div className="col-md-6 ">
                          <div className="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div className="text-end pt-2">Deepak Arora</div>
                        </div>

                        <div className="col-md-6">
                          <div className="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div className="text-end pt-2">Hari Kiran</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wcu pt-5 pb-5">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <h6>Why Choose Us</h6>
                <h1 className="pt-3 pb-3 display-5">
                  Offer Tailor Made Services That Our Client Requires
                </h1>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="DirectInterviews-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#DirectInterviews"
                      type="button"
                      role="tab"
                      aria-controls="DirectInterviews"
                      aria-selected="true"
                    >
                      <i className="ri-team-line"></i>
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="FasterProcessing-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#FasterProcessing"
                      type="button"
                      role="tab"
                      aria-controls="FasterProcessing"
                      aria-selected="false"
                    >
                      <i className="ri-id-card-line"></i>
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="VisaAssistance-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#VisaAssistance"
                      type="button"
                      role="tab"
                      aria-controls="VisaAssistance"
                      aria-selected="false"
                    >
                      <i className="ri-flight-takeoff-line"></i>
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="CostEffective-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#CostEffective"
                      type="button"
                      role="tab"
                      aria-controls="CostEffective"
                      aria-selected="false"
                    >
                      <i className="ri-money-rupee-circle-line"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="DirectInterviews"
                    role="tabpanel"
                    aria-labelledby="DirectInterviews-tab"
                  >
                    <div>
                      <h2 className="display-6">Direct Interviews</h2>
                      <img
                        src={imageInterview}
                        alt="Direct Interviews"
                        className="img-fluid"
                      />
                      <p className="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a href="#" className="Explore">
                        <i className="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="FasterProcessing"
                    role="tabpanel"
                    aria-labelledby="FasterProcessing-tab"
                  >
                    <div>
                      <h2 className="display-6">Faster Processing</h2>
                      <img
                        src={imageProcesser}
                        alt="Faster Processing"
                        className="img-fluid"
                      />
                      <p className="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a href="#" className="Explore">
                        <i className="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="VisaAssistance"
                    role="tabpanel"
                    aria-labelledby="VisaAssistance-tab"
                  >
                    <div>
                      <h2 className="display-6">Visa Assistance</h2>
                      <img
                       src={imageVisa}
                        alt="Visa Assistance"
                        className="img-fluid"
                      />
                      <p className="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a href="#" className="Explore">
                        <i className="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="CostEffective"
                    role="tabpanel"
                    aria-labelledby="CostEffective-tab"
                  >
                    <div>
                      <h2 className="display-6">Cost-Effective</h2>
                      <img
                        src={imageCost}
                        alt="Cost-Effective
                    "
                        className="img-fluid"
                      />
                      <p className="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a href="#" className="Explore">
                        <i className="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
